import { render, staticRenderFns } from "./CrudEdit.vue?vue&type=template&id=1bd9f526&"
import script from "./CrudEdit.vue?vue&type=script&lang=js&"
export * from "./CrudEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports